{ Observable } = require "jadelet"

module.exports = Observable
